/**
 * Variante du StatusBadge pour le header de la page detail (taille XL).
 * Reuse les memes classes color que StatusBadge mais en padding plus grand.
 */

const STATUS_CONFIG = {
  annonce: { label: 'Annonce', cls: 'bg-gray-100 text-gray-700' },
  collecte: { label: 'Collecte en cours', cls: 'bg-orange-50 text-orange-700' },
  pret_generation: { label: 'Pret a generer', cls: 'bg-blue-50 text-blue-700' },
  attente_signature: { label: 'Signature en attente', cls: 'bg-blue-50 text-blue-700' },
  transmis: { label: 'Complet', cls: 'bg-emerald-50 text-emerald-700' },
  depot_cee: { label: 'Attente depot CEE', cls: 'bg-emerald-50 text-emerald-700' },
  logistique: { label: 'Livraison en cours', cls: 'bg-purple-50 text-purple-700' },
  cloture: { label: 'Termine', cls: 'bg-gray-100 text-gray-700' },
  bloque: { label: 'Bloque', cls: 'bg-red-50 text-red-700' },
};

/**
 * @param {{ status: string, blockingReason?: string | null }} props
 */
export default function StatusBadgeLarge({ status, blockingReason }) {
  const cfg = STATUS_CONFIG[status] || { label: status, cls: 'bg-gray-100 text-gray-700' };
  return (
    <div className="inline-flex flex-col gap-0.5">
      <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-semibold ${cfg.cls}`}>
        {(status === 'bloque' || (blockingReason && status === 'collecte')) && <span className="text-red-500">!</span>}
        {cfg.label}
      </span>
      {blockingReason && (
        <span className="text-xs text-red-600 italic ml-1">{blockingReason}</span>
      )}
    </div>
  );
}
